var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ChartParams } from "../../views/chart/chart.component";
import { parseDate } from "../../lib/lib";
import { BillingService2 } from "../billing.service";
import merge from "lodash-es/merge";
function formatChartData(filterParam, charts) {
    if (filterParam.chartFormat === 'c3angular') {
        /*
        {
            12312323434: {
                countReg: 10,
                siteCount: 100
            },
            12312323435: {
                countReg: 100
            },
            12312323436: {
                siteCount: 112
            },
            ...
        }
         */
        /*
            [
                ['x', 12312323434, 12312323435, 12312323436, ...],
                [ 'countReg', 10, 100, 0, ...],
                [ 'siteCount', 100, 0, 112, ...],
                ...
            ]
         */
        // получить список timeline
        var timeline = Object.keys(charts);
        // получить список всех ключей
        var keyMap = timeline.reduce(function (obj, ts) {
            for (var _i = 0, _a = Object.keys(charts[ts]); _i < _a.length; _i++) {
                var key = _a[_i];
                obj[key] = 1;
            }
            return obj;
        }, {});
        var orderedTimeline = timeline.map(function (ts) { return parseInt(ts, 10); }).sort(function (a, b) { return a - b; });
        var columns = [];
        var keyList = Object.keys(keyMap);
        for (var _i = 0, keyList_1 = keyList; _i < keyList_1.length; _i++) {
            var key = keyList_1[_i];
            var row = [key];
            for (var _a = 0, orderedTimeline_1 = orderedTimeline; _a < orderedTimeline_1.length; _a++) {
                var ts = orderedTimeline_1[_a];
                row.push(charts[ts][key] || 0);
            }
            columns.push(row);
        }
        columns.unshift([].concat(['x'], orderedTimeline));
        charts = columns;
    }
    else if (filterParam.chartFormat === 'c3') {
    }
    else {
    }
    return charts;
}
;
function roundBy(number, countNumberAfterZero) {
    if (countNumberAfterZero === void 0) { countNumberAfterZero = 2; }
    var i = Math.pow(10, countNumberAfterZero);
    return (isNaN(number) ? 0 : Math.round(number * i) / i);
}
var TailComponent = /** @class */ (function (_super) {
    __extends(TailComponent, _super);
    function TailComponent(activatedRoute, translate, filter, eventsService, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.service2 = service2;
        _this.rows = [];
        _this.listLoader = false;
        _this.params = {
            user21billingStart: 0,
            user21billingEnd: 21
        };
        _this.addFilterParams = {
            userType: 'user',
            isExpiredPaid: true,
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
            processorType: 'all',
            userRegType: 'usersWithOrNotSite',
        };
        _this.withTailChart = new ChartParams({
            title: 'С хвостом',
            tooltip: {
                format: {
                    title: function (value) { return parseDate(value).format('MMMM'); },
                    value: function (value) { return roundBy(value); },
                }
            },
            axis: {
                x: {
                    tick: {
                        format: function (value) { return parseDate(value).format('MMMM'); },
                    }
                }
            },
        });
        _this.withoutTailChart = new ChartParams({
            title: 'Без хвоста',
            tooltip: {
                format: {
                    title: function (value) { return parseDate(value).format('MMMM'); },
                    value: function (value) { return roundBy(value); },
                }
            },
            axis: {
                x: {
                    tick: {
                        format: function (value) { return parseDate(value).format('MMMM'); },
                    }
                }
            },
        });
        _this.onlyTailChart = new ChartParams({
            title: 'Хвост',
            tooltip: {
                format: {
                    title: function (value) { return parseDate(value).format('MMMM'); },
                    value: function (value) { return roundBy(value); },
                }
            },
            axis: {
                x: {
                    tick: {
                        format: function (value) { return parseDate(value).format('MMMM'); },
                    }
                }
            },
        });
        var me = _this;
        Object.keys(me.params).forEach(function (k) {
            me.params[k] = filter.defaultFilterParams[k];
        });
        return _this;
    }
    TailComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TailComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _loop_1, this_1, _i, _a, chartName;
            return __generator(this, function (_b) {
                me = this;
                me.withTailChart.showLoader();
                me.withoutTailChart.showLoader();
                me.onlyTailChart.showLoader();
                _loop_1 = function (chartName) {
                    var charts = {};
                    var yearMap = {};
                    this_1.rows.forEach(function (row) {
                        if (row.type !== 'month') {
                            return true;
                        }
                        var dateM = parseDate(row.date);
                        var month = dateM.clone().startOf('month').year(1970).valueOf();
                        var year = dateM.year();
                        if (!charts[month]) {
                            charts[month] = {};
                        }
                        if (!charts[month][year]) {
                            charts[month][year] = 0;
                        }
                        var conversion = 0;
                        if (chartName === 'withTail') {
                            conversion = 100 * (row.headCount + row.tailCount) / row.usersWithSite;
                        }
                        else if (chartName === 'withoutTail') {
                            conversion = 100 * (row.headCount) / row.usersWithSite;
                        }
                        else if (chartName === 'onlyTail') {
                            conversion = 100 * (row.tailCount) / row.usersWithSite;
                        }
                        charts[month][year] += conversion;
                        yearMap[year] = 1;
                    });
                    me[chartName + "Chart"].data = formatChartData({
                        chartFormat: 'c3angular'
                    }, charts);
                };
                this_1 = this;
                for (_i = 0, _a = ['withTail', 'withoutTail', 'onlyTail']; _i < _a.length; _i++) {
                    chartName = _a[_i];
                    _loop_1(chartName);
                }
                me.withTailChart.hideLoader();
                me.withoutTailChart.hideLoader();
                me.onlyTailChart.hideLoader();
                return [2 /*return*/];
            });
        });
    };
    TailComponent.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, items, isShowMiddleCaption, _i, items_1, item, data, row;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.service.q$.reset();
                        fp = me.filter.getFilterParams();
                        me.rows = [];
                        me.listLoader = true;
                        me.withTailChart.showLoader();
                        me.withoutTailChart.showLoader();
                        me.onlyTailChart.showLoader();
                        return [4 /*yield*/, me.service2.tail.stats(fp).toPromise()];
                    case 1:
                        items = (_a.sent()).stats;
                        isShowMiddleCaption = false;
                        _i = 0, items_1 = items;
                        _a.label = 2;
                    case 2:
                        if (!(_i < items_1.length)) return [3 /*break*/, 5];
                        item = items_1[_i];
                        return [4 /*yield*/, me.service2.tail.total(fp, "info/" + item.type + "/" + item.date).toPromise()];
                    case 3:
                        data = (_a.sent()).totals;
                        if (me.listLoader) {
                            me.listLoader = false;
                        }
                        row = merge({}, item, data);
                        if (row.type == 'year' && !isShowMiddleCaption) {
                            isShowMiddleCaption = true;
                            me.rows.push({ middleCaption: true });
                        }
                        row['headPercent'] = me.roundBy(100 * (row.headCount / (row.headCount + row.tailCount)), 2);
                        me.rows.push(row);
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, me.getChart()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TailComponent.prototype.roundBy = function (number, countNumberAfterZero) {
        return roundBy(number, countNumberAfterZero);
    };
    TailComponent.prototype.userRegTypeChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TailComponent;
}(BaseComponent));
export { TailComponent };
